/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Input } from '@angular/core';

import { ExportLogBtn } from '../export/export.enum';

@Component({
    selector: 'app-simple-time-and-size',
    templateUrl: './simple-time-and-size.component.html',
    styleUrls: ['../export/export.component.scss'],
})
export class SimpleTimeAndSizeComponent {
    /**
     * 用于HTML元素的ID
     */
    @Input() tipId: string;
    /**
     * 是否需要隐藏
     */
    @Input() hidden: boolean;
    /**
     * 日志对象
     */
    @Input() exportLog: ExportLogBtn;
}
